import React from 'react';
import axios from 'axios';
import { addLocaleData } from 'react-intl';

import { WtlContext } from 'wtl-components-library/web/context/wtl-context';
import VariablesService from '@root/wtl-schema/services/variable.service';

import './src/styles/ant.elements.css';
import './src/styles/ant.reset-typography.css';
import './src/styles/wtl.grid.css';
import './src/styles/wtl.effect.css';

import favIcon from './src/images/favicon.png';

// NOTE Add languages here (import intl locale to make messages work)
import enLocale from 'react-intl/locale-data/en';

import en from './i18n/en';

export const localeData = { en };
export const localeIntl = [
  ...enLocale
];
export const availableLanguages = Object.keys(localeData);

addLocaleData(localeIntl);

// END of languages

// NOTE Add animation engine

if (typeof window !== 'undefined') {
  const aos = require('aos');
  require('aos/dist/aos.css');

  aos.init();
}

// END of animation engine

// NOTE Generated

export const library = JSON.parse(`[]`);
export const behaviours = JSON.parse(`[]`);
export const options = JSON.parse(`{"preloadFonts":true,"compat_align_v1":"false"}`);

// END of generated

// NOTE Initial Variables

JSON.parse(`[]`).forEach(({ key, value }) => VariablesService.setVar(key, value));

export const config = {
  /**
   * Page URLs
   */
  SITE_URL: `https://daylightsquad.wtlstudio.com`,
  API_URL: 'https://j81eal5nn6.execute-api.us-east-1.amazonaws.com/wtl-live/',
  TWITTER_URL: '',

  /**
   * Metadata and SEO
   */
  FAV_ICON: 'https://cdn.wtlstudio.com/daylightsquad.wtlstudio.com/3944755d-bf40-4855-83a0-c23d4c705bdf.png',
  DEFAULT_LOCALE: 'en',
  DEFAULT_TITLE: 'Daylight Squad for Android and iOS - WTL Studio Games',
  SEO_LOGO: '',
  SEO_DESCRIPTION: ``,
  SEO_KEYWORDS: [
    
  ],
  
  /**
   * Plugin Configuration
   */
  enabledPlugins: [
    
  ],

  /**
   * Third Party API
   */
  STRIPE_API_KEY: '',
  GOOGLE_TRACK_ID: '',
  GOOGLE_MAPS_API_KEY: '',
  GOOGLE_SEARCH_CONSOLE_VERIFICATION_ID: ''
};

export const schemaSettings = {
  COLUMN_COUNT: 24
};

export const getApiEndpoint = (endpoint) => `${config.API_URL}${endpoint}`;

export const callApi = (endpoint, method = 'GET', params, headers) => {
  let call = axios({
    method: method.toLowerCase(),
    url: getApiEndpoint(endpoint),
    withCredentials: false,
    params: method === 'GET' ? params : {},
    data: method === 'POST' ? params : {},
    headers
  });

  return call
  .then(response => {
    return response.data;
  });
}

// NOTE Rendering Context Wrapper
export const WtlContextWrapper = ({ children }) => (
  <WtlContext.Provider value={
    {
      config,
      availableLanguages,
      localeData,
      localeIntl
    }
  }>
    <>
      {children}
    </>
  </WtlContext.Provider>
);
